import {
  ExperienceReservation,
  ExperienceReservationResponse,
  MyTripsFilter,
} from "redmond";
import { put, call, select } from "redux-saga/effects";
import { fetchExperiences } from "../../../api/v1/itinerary/fetchExperiences";
import { actions } from "../actions";
import { setUpMyTripsParams } from "./setUpTripsParams";
import { getExperiences } from "../reducer";

export function* fetchExperiencesSaga(action: actions.IFetchExperiences) {
  try {
    const { tripId } = yield call(setUpMyTripsParams, action);
    const experiencesReservationResponse: ExperienceReservationResponse =
      yield fetchExperiences(action.request);

    const existingExperiences: { [key: string]: ExperienceReservation[] } =
      yield select(getExperiences);
    const {
      future = [...existingExperiences.future],
      canceled = [...existingExperiences.canceled],
      past = [...existingExperiences.past],
      present = [...existingExperiences.present],
    } = experiencesReservationResponse.itineraries;

    let selectedExperience = null;
    let selectedExperienceFilter: MyTripsFilter | null = null;

    if (tripId) {
      selectedExperience = [...future].find(
        (experience: ExperienceReservation) =>
          experience.reservation.customerReservationId === tripId ||
          experience.reservation.bookingSession?.cartOrderedProductId === tripId
      );
      if (!selectedExperience) {
        const canceledExperience = [...canceled].find(
          (experience: ExperienceReservation) =>
            experience.reservation.customerReservationId === tripId ||
            experience.reservation.bookingSession?.cartOrderedProductId ===
              tripId
        );
        if (canceledExperience) {
          selectedExperience = canceledExperience;
          selectedExperienceFilter = MyTripsFilter.CANCELED_TRIPS;
        } else {
          const pastExperience = [...past].find(
            (experience: ExperienceReservation) =>
              experience.reservation.customerReservationId === tripId ||
              experience.reservation.bookingSession?.cartOrderedProductId ===
                tripId
          );
          if (pastExperience) {
            selectedExperience = pastExperience;
            selectedExperienceFilter = MyTripsFilter.PAST_TRIPS;
          }
        }
      }
    }

    if (selectedExperienceFilter) {
      yield put(actions.setTripsFilter(selectedExperienceFilter));
      yield put(actions.populateTripQueryParams(action.history, { tripId }));
    }
    if (selectedExperience) {
      yield put(
        actions.setSelectedExperience({
          ...selectedExperience,
        })
      );
    }

    yield put(
      actions.setExperiences(
        {
          present,
          canceled,
          past,
          future,
        },
        action.request.states
      )
    );
  } catch (e) {
    yield put(actions.fetchExperiencesFailed(action.request));
    console.error(e);
  }
}
